import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'

import { graphql, compose, withApollo } from 'react-apollo'
import { withRouter } from 'react-router-dom'

import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import Button from '@material-ui/core/Button'
import IconButton from '@material-ui/core/IconButton'
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import CardActions from '@material-ui/core/CardActions'
import LinearProgress from '@material-ui/core/LinearProgress'

import { withSnackbar } from 'notistack'

import HeroLocation from '../../components/HeroLocation'
import { styles } from './styles'
import { GET_USER_AUTHENTICATED } from '../../graphql/queries'
import { UPDATE_USER } from '../../graphql/mutations'
import { isMobile } from '../../utils'
import { withContext } from '../../context'
import Logo from '../../components/Logo'
import Title from '../../components/Title'
import SuccesDialog from './components/SuccessDialog'

export const Location = ({
  me,
  heroConfig,
  UpdateUser,
  enqueueSnackbar,
  context: { state, setState }
}) => {
  const [openDialog, setOpenDialog] = useState(false)

  useEffect(() => {
    if (heroConfig.locationCount === 0) {
      setOpenDialog(true)
    }
  }, [])

  const handleRegister = async () => {
    setState(...state, { uploading: true })

    let result = false
    try {
      result = await UpdateUser({
        variables: {
          id: me.id,
          data: {
            status: 'PENDING'
          }
        },
        refetchQueries: [{ query: GET_USER_AUTHENTICATED }]
      })

      if (result) {
        setState(...state, { uploading: false })
      }
    } catch (error) {
      enqueueSnackbar(error.message)
    }
  }

  if (heroConfig.locationCount > 0) {
    return (
      <React.Fragment>
        <AppBar position="sticky">
          <Toolbar style={styles.toolbar}>
            <IconButton style={{ width: '48px' }} />
            <Logo />
            <IconButton style={{ width: '48px' }} />
          </Toolbar>
        </AppBar>

        {state.uploading && <LinearProgress />}

        <Title name="สถานที่ตั้งของท่าน (Locations)" />

        <Card elevation={isMobile ? 0 : 1} square>
          <CardContent>
            <HeroLocation hero={me} heroConfig={heroConfig} />
          </CardContent>
          <CardActions>
            <Button
              id="btnSubmit"
              variant="contained"
              color="primary"
              fullWidth
              onClick={() => {
                if (me.heroType === 'CIRCULAR_BIN') {
                  handleRegister()
                } else {
                  setOpenDialog(true)
                }
              }}
            >
              Next
            </Button>
          </CardActions>
        </Card>

        <SuccesDialog open={openDialog} onOk={() => handleRegister()} />
      </React.Fragment>
    )
  } else {
    return (
      <SuccesDialog
        open={openDialog}
        onOk={async () => {
          await handleRegister()
          setOpenDialog(false)
        }}
      />
    )
  }
}

Location.propTypes = {
  me: PropTypes.object.isRequired,
  UpdateUser: PropTypes.func.isRequired,
  enqueueSnackbar: PropTypes.func.isRequired,
  context: PropTypes.object.isRequired,
  heroConfig: PropTypes.object.isRequired
}

export default compose(
  withRouter,
  withApollo,
  withSnackbar,
  withContext,
  graphql(UPDATE_USER, { name: 'UpdateUser' })
)(Location)



// WEBPACK FOOTER //
// ./src/pages/Location/index.js